import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { Router } from '@angular/router';
import { Caller } from '../../_models/caller';
import { Register } from '../../_models/register';
import { Globals } from '../../_models/globals';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  errorMessage: string = "";

  constructor(public http: HttpClient, private router: Router
    , private caller: Caller, public register: Register
    , public g: Globals) {
  }

  ngOnInit() {
  }

  onSelectEmail() {
    this.errorMessage = "";
    if (this.register.mobile == '' || this.register.mobile === null || this.register.mobile === undefined || this.register.mobile === 'undefined') {
      this.errorMessage = "Please enter your Email Id or Mobile Number";
      return false;
    }
  }


  forgotPasswordRequest() {
    this.errorMessage = "";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/forgotPassword?userName=' + this.register.mobile,
      { headers: header1 }).subscribe(data => {
        this.caller.parent = "FORGOT_PASSWORD";
        if (data['mode'] === 'MOBILE' && data['code'] == 200) {
          this.router.navigate(['/access/otp']);
        } else if (data['mode'] === 'EMAIL' && data['code'] == 200) {
          this.router.navigate(['/access/info']);
        }
        else {
          this.errorMessage = "Invalid Email id or Mobile Number"
        }
        (err: HttpErrorResponse) => {
          console.log(err);
          this.errorMessage = "uniqueEmail Failed, please re-try.";
        }
      })
  }
}
